<style lang="less" scoped>
@import '../../../style/common/variable';
.qyzx {display: flex;width: 1200px;line-height: 30px;height: 30px;padding: 0;margin: 10px auto;font-size: 16px;font-family: AlibabaPuHuiTi-Medium;font-weight: normal;font-stretch: normal;letter-spacing: 1px;color: #000000;}
/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {font-weight: 400;color: #606266;cursor: text;}
/deep/.el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover {font-weight: 400;color: #606266;cursor: text;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .qyzx {flex-wrap: wrap;width: calc(100vw - .1rem); margin-top: .1rem; margin-left: .1rem;font-size: .14rem;}
}
</style>

<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="qyzx">
    <span class="current">当前位置：</span>
    <el-breadcrumb-item v-for="(item, index) in navigationdata" :key="index" :to="{ path: item.path }">{{ item.theme }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<!-- 安进 2021.6.15
     面包屑导航组件
-->
<script>
export default {
  props: ['navigationdatas'],
  data()
  {
    return {
      navigationdata: this.navigationdatas, //面包屑导航
      curid: null,
      catid: null,
      breadList: []
    }
  },
  watch: {
    $route: {
      handler(nval, oval)
      {
        if (nval.name === 'ZlkDetails' || nval.name === 'ZlkList' || nval.name === 'ZlkDetails' || nval.name === 'ZlkDetails')
        {
          if (nval.query.id)
          {
            this.curid = +nval.query.id
            this.getIdNAV()
          }
          else if (nval.query.catid)
          {
            this.catid = +nval.query.catid
            this.getCatidNAV()
          }
        }
      },
      immediate: true
    }
  },
  methods:
  {
    getIdNAV()
    {
      this.navigationdata = []
      if (this.isMobile)
        this.navigationdata.push({theme: '首页', path: '/KyforumApp'}, {theme: '资料库', path: '/ZlkTabsList'})
      else
        this.navigationdata.push({theme: '首页', path: '/Kyforum'}, {theme: '资料库', path: '/ZlkTabsList'})
      let arrparentidarr = []//父caiid数组
      let parasId = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id=?', types: 'i', vals: this.curid}
      window.post.getPost(parasId).then((ret) =>
      {
        let parasCatid = {cmd: 'query', _major: 11, _minor: 36, _exp: 'id=?', types: 'i', vals: ret[0].catid}
        window.post.getPost(parasCatid).then((ret) =>
        {
          arrparentidarr = ret[0].arrparentid.split(',').map(Number)
          arrparentidarr.splice(0, 1)
          if (arrparentidarr.length === 1)
          {
            switch (arrparentidarr[0])
            {
            case 100 : this.navigationdata.push({theme: '政策法规', path: '/ZlkListDouble?catid=100'})
              break
            case 101 : this.navigationdata.push({theme: '投资环境', path: '/ZlkListDouble?catid=101'})
              break
            }
          }
          else if (arrparentidarr.length === 2)
          {
            switch (arrparentidarr[0])
            {
            case 99 : this.navigationdata.push({theme: '地质矿产', path: '/ZlkTabsList1?catid=99'})
              break
            case 102 : this.navigationdata.push({theme: '矿业技术', path: '/ZlkTabsList1?catid=102'})
              break
            }
            switch (arrparentidarr[1])
            {
            case 160 : this.navigationdata.push({theme: '基础地质', path: '/ZlkListDouble?catid=160'})
              break
            case 161 : this.navigationdata.push({theme: '矿产资源', path: '/ZlkListDouble?catid=161'})
              break
            case 162 : this.navigationdata.push({theme: '找矿研究', path: '/ZlkListDouble?catid=162'})
              break
            case 134 : this.navigationdata.push({theme: '地质勘察', path: '/ZlkListDouble?catid=134'})
              break
            case 131 : this.navigationdata.push({theme: '采矿技术', path: '/ZlkListDouble?catid=131'})
              break
            case 129 : this.navigationdata.push({theme: '选矿技术', path: '/ZlkListDouble?catid=129'})
              break
            case 132 : this.navigationdata.push({theme: '化验检测', path: '/ZlkListDouble?catid=132'})
              break
            case 130 : this.navigationdata.push({theme: '材料冶金', path: '/ZlkListDouble?catid=30'})
              break
            case 133 : this.navigationdata.push({theme: '安全环保', path: '/ZlkListDouble?catid=133'})
              break
            case 135 : this.navigationdata.push({theme: '二次资源', path: '/ZlkListDouble?catid=135'})
              break
            }
          }
          this.navigationdata.push({theme: ret[0].catname, path: `/ZlkList?catid=${ret[0].id}`})
          if (this.$route.path === '/ZlkDetails')
            this.navigationdata.push({theme: '正文', path: '/'})
        })
      })
    },
    getBreadcrumb()
    {
      const breadNumber = typeof (this.$route.meta.breadNumber) !== 'undefined' ? this.$route.meta.breadNumber : 0
      const newBread = { name: this.$route.name, path: this.$route.fullPath }
      this.breadList = JSON.parse(sessionStorage.getItem('breadListStorage')) || []
      this.breadList.splice(breadNumber, this.breadList.length - breadNumber, newBread)
      sessionStorage.setItem('breadListStorage', JSON.stringify(this.breadList))
    },
    getCatidNAV()
    {
      this.navigationdata = []
      if (this.isMobile)
        this.navigationdata.push({theme: '首页', path: '/KyforumApp'}, {theme: '资料库', path: '/ZlkTabsList'})
      else
        this.navigationdata.push({theme: '首页', path: '/Kyforum'}, {theme: '资料库', path: '/ZlkTabsList'})
      let arrparentidarr = []//父caiid数组
      let parasCatid = {cmd: 'query', _major: 11, _minor: 36, _exp: 'id=?', types: 'i', vals: this.catid}
      window.post.getPost(parasCatid).then((ret) =>
      {
        arrparentidarr = ret[0].arrparentid.split(',').map(Number)
        arrparentidarr.splice(0, 1)
        if (arrparentidarr.length === 1)
        {
          switch (arrparentidarr[0])
          {
          case 100 : this.navigationdata.push({theme: '政策法规', path: '/ZlkListDouble?catid=100'})
            break
          case 101 : this.navigationdata.push({theme: '投资环境', path: '/ZlkListDouble?catid=101'})
            break
          }
        }
        else if (arrparentidarr.length === 2)
        {
          switch (arrparentidarr[0])
          {
          case 99 : this.navigationdata.push({theme: '地质矿产', path: '/ZlkListDouble?catid=99'})
            break
          case 102 : this.navigationdata.push({theme: '矿业技术', path: '/ZlkListDouble?catid=102'})
            break
          }
          switch (arrparentidarr[1])
          {
          case 160 : this.navigationdata.push({theme: '基础地质', path: '/ZlkListDouble?catid=160'})
            break
          case 161 : this.navigationdata.push({theme: '矿产资源', path: '/ZlkListDouble?catid=161'})
            break
          case 162 : this.navigationdata.push({theme: '找矿研究', path: '/ZlkListDouble?catid=162'})
            break
          case 134 : this.navigationdata.push({theme: '地质勘察', path: '/ZlkListDouble?catid=134'})
            break
          case 131 : this.navigationdata.push({theme: '采矿技术', path: '/ZlkListDouble?catid=131'})
            break
          case 129 : this.navigationdata.push({theme: '选矿技术', path: '/ZlkListDouble?catid=129'})
            break
          case 132 : this.navigationdata.push({theme: '化验检测', path: '/ZlkListDouble?catid=132'})
            break
          case 130 : this.navigationdata.push({theme: '材料冶金', path: '/ZlkListDouble?catid=130'})
            break
          case 133 : this.navigationdata.push({theme: '安全环保', path: '/ZlkListDouble?catid=133'})
            break
          case 135 : this.navigationdata.push({theme: '二次资源', path: '/ZlkListDouble?catid=135'})
            break
          }
        }
        this.navigationdata.push({theme: ret[0].catname, path: `/ZlkList?catid=${ret[0].id}`})
        if (this.$route.path === '/ZlkDetails')
          this.navigationdata.push({theme: '正文', path: '/'})
      })
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Navigation.vue